module.exports = __webpack_public_path__ + "img/ava1.2bbcc32f.svg";